import React, { useState, useEffect } from "react";
import Button from "../Button/Button";
import RelativeTime from "../RelativeTime";

import InputField from "../InputField/InputField";
import Check from "../../icons/check.svg";

import { canChangeK } from "../../utils/perm";

import IfPermission from "../../components/IfPermission";

const CardInfo = ({ card, onSetRatio, onSetPacket }) => {
  const [ratio, setRatio] = useState(card.ratio);
  const [packet, setPacket] = useState(card.packet);

  useEffect(() => {
    setRatio(card.ratio);
    setPacket(card.packet);
  }, [card.ratio, card.packet]);

  const handleRatioChange = () => {
    onSetRatio(ratio);
  };

  const handlePacketChange = () => {
    onSetPacket(packet);
  };

  return (
    <div className="card__info">
      <div className="card__stat card__stat_top">
        <div>
          За сегодня <br />
          <b>{card.today_teasers_count} анонсов</b>
        </div>
        <div>
          В процессе:
          <br />
          {card.user_id ? (
            <b>
              <RelativeTime time={card.start_time} />
            </b>
          ) : (
            <b>-</b>
          )}
        </div>
      </div>

      <div className="card__info_divider" />

      <div className="card__stat card__stat_middle">
        <div>
          Долг: <br />
          Ранг: <br />
          Анонсы: <br />
          Обновление: <br />
          <IfPermission checker={canChangeK}>
            Об. Коэф: <br />
            Пакет: <br />
            Коэф: <br />
          </IfPermission>
        </div>
        <div>
          <b>{card.debt_percent}%</b> <br />
          <b>{card.rank || "Нет долга"}</b> <br />
          <b>{card.all_teasers_count}</b> <br />
          <b>
            <RelativeTime time={card.last_teaser_add} />
            <br />
          </b>
          <IfPermission checker={canChangeK}>
            <b>{card.required_k}</b>
            <br />
            <div className="card__input-group">
              <InputField
                className="card__k_input"
                value={packet}
                onChange={e => {
                  setPacket(e.target.value);
                }}
              />
              <Button
                color="green"
                icon={Check}
                className="card__k-btn"
                onClick={handlePacketChange}
              />
            </div>
            <div className="card__input-group">
              <InputField
                className="card__k_input"
                value={ratio}
                onChange={e => {
                  setRatio(e.target.value);
                }}
              />
              <Button
                color="green"
                icon={Check}
                className="card__k-btn"
                onClick={handleRatioChange}
              />
            </div>
            <br />
          </IfPermission>
        </div>
      </div>
    </div>
  );
};

export default CardInfo;
